import {FinanzamtMapperService} from './finanzamt-mapper.service';
import {Injectable, Injector} from '@angular/core';
import {RechtsformEnum, RechtsformEnumLabels, StammdatenRechtsformEnum, StammdatenUnternehmen} from '@nachdigal';
import {MappedStammdatenUnternehmen} from '@utils-lib';
import {BankverbindungMapperService} from './bankverbindung-mapper.service';
import {AbstractMapper} from '../../abstract.mapper';
import {InlandsadresseMapperService} from './inlandsadresse-mapper.service';
import {AuslandsadresseMapperService} from './auslandsadresse-mapper.service';
import {PostfachadresseMapperService} from './postfachadresse-mapper.service';
import {KommunikationsmittelMapperService} from './kommunikationsmittel-mapper.service';
import {GrossempfaengerMapperService} from './grossempfaenger-mapper.service';
import {AbweichenderOrtGeschaeftsleitungMapperService} from './abweichender-ort-geschaeftsleitung-mapper.service';
import {BetriebstaettenMapperService} from './betriebstaetten-mapper.service';
import {HandelsregistereintragMapperService} from './handelsregistereintrag-mapper.service';
import {AnteilseignerMapperService} from './anteilseigner-mapper.service';
import {BeteiligteMapperService} from './beteiligte-mapper.service';

@Injectable()
export class UnternehmenMapperService extends AbstractMapper<StammdatenUnternehmen, MappedStammdatenUnternehmen> {

  private readonly bankverbindungMapper: BankverbindungMapperService;
  private readonly inlandsadresseMapper: InlandsadresseMapperService;
  private readonly auslandsadresseMapper: AuslandsadresseMapperService;
  private readonly postfachadresseMapper: PostfachadresseMapperService;
  private readonly grossempfaengerMapper: GrossempfaengerMapperService;
  private readonly kommunikationsmittelMapper: KommunikationsmittelMapperService;
  private readonly abweichenderOrtGeschaeftsleitungMapper: AbweichenderOrtGeschaeftsleitungMapperService;
  private readonly betriebstaettenMapper: BetriebstaettenMapperService;
  private readonly handelsregistereintragMapper: HandelsregistereintragMapperService;
  private readonly anteilseignerMapperService: AnteilseignerMapperService;
  private readonly beteiligteMapperService: BeteiligteMapperService;
  private readonly finanzamtMapperService: FinanzamtMapperService;

  constructor(private readonly injector: Injector) {
    super();
    this.bankverbindungMapper = injector.get<BankverbindungMapperService>(BankverbindungMapperService);
    this.inlandsadresseMapper = injector.get<InlandsadresseMapperService>(InlandsadresseMapperService);
    this.auslandsadresseMapper = injector.get<AuslandsadresseMapperService>(AuslandsadresseMapperService);
    this.postfachadresseMapper = injector.get<PostfachadresseMapperService>(PostfachadresseMapperService);
    this.grossempfaengerMapper = injector.get<GrossempfaengerMapperService>(GrossempfaengerMapperService);
    this.kommunikationsmittelMapper =
      injector.get<KommunikationsmittelMapperService>(KommunikationsmittelMapperService);
    this.abweichenderOrtGeschaeftsleitungMapper =
      injector.get<AbweichenderOrtGeschaeftsleitungMapperService>(AbweichenderOrtGeschaeftsleitungMapperService);
    this.betriebstaettenMapper = injector.get<BetriebstaettenMapperService>(BetriebstaettenMapperService);
    this.handelsregistereintragMapper =
      injector.get<HandelsregistereintragMapperService>(HandelsregistereintragMapperService);
    this.anteilseignerMapperService = injector.get<AnteilseignerMapperService>(AnteilseignerMapperService);
    this.beteiligteMapperService = injector.get<BeteiligteMapperService>(BeteiligteMapperService);
    this.finanzamtMapperService = injector.get<FinanzamtMapperService>(FinanzamtMapperService);
  }

  private static getRechtsform(stammdatenRechtsform: StammdatenRechtsformEnum): RechtsformEnum {
    if (stammdatenRechtsform == null) {
      return null;
    }
    for (const key in RechtsformEnumLabels) {
      if (stammdatenRechtsform === RechtsformEnumLabels[key]) {
        return RechtsformEnumLabels[key];
      }
    }
    return null;
  }

  protected mapInternal(source: StammdatenUnternehmen): MappedStammdatenUnternehmen {
    return {
      firmenname: source.firmenname,
      beginnTaetigkeit: source.beginnTaetigkeit,
      inlandsadressen: this.inlandsadresseMapper.mapArrayWithDefault(source.adressen),
      auslandsadressen: this.auslandsadresseMapper.mapArrayWithDefault(source.adressen),
      postfachadressen: this.postfachadresseMapper.mapArrayWithDefault(source.adressen),
      grossempfaengeradressen: this.grossempfaengerMapper.mapArrayWithDefault(source.adressen),
      kommunikation: this.kommunikationsmittelMapper.map(source.kommunikation),
      bankverbindungen: this.bankverbindungMapper.mapArrayWithDefault(source.bankverbindungen),
      abweichenderOrtGeschaeftsleitung: this.abweichenderOrtGeschaeftsleitungMapper.map(source),
      betriebstaetten: this.betriebstaettenMapper.mapArrayWithStammdatenIndex(source.betriebstaetten),
      handelsregistereintrag: this.handelsregistereintragMapper.map(source.handelsregistereintrag),
      ortDesSitzes: source.firmensitzOrt,
      datumGVertrag: source.datumGVertrag,
      rechtsform: UnternehmenMapperService.getRechtsform(source.rechtsform),
      wirtschaftsJahr: source.wirtschaftsjahr,
      anteilseigner: this.anteilseignerMapperService.mapArrayWithStammdatenIndex(source.beteiligte),
      beteiligte: this.beteiligteMapperService.mapArrayWithStammdatenIndex(source.beteiligte),
      finanzamt: this.finanzamtMapperService.map(source.finanzamt)
    };
  }

}
